module.exports = __webpack_public_path__ + "images/emoji/waxing_crescent_moon.85d6569362b770a9337d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/waxing_crescent_moon.png
// module id = v14a
// module chunks = 1